<div class="d-flex justify-content-center mt-4">
  <div *ngIf="isLoading"
       class="spinner-border text-primary"
       style="width: 8rem; height: 8rem;"
       role="status">
    <span class="sr-only">Loading...</span>
  </div>
</div>

